import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import ListItem from './ListItem';
import { baseButtonStyles } from './shared/styles';

const Button = styled.button`
  ${baseButtonStyles}
  color: var(--cc_color_link_primary);
  font-weight: 500;
  font-size: var(--cc_size_text_m);
  &:hover {
    color: var(--cc_color_link_primary_darken_15);
  }
`;

const handleClick = (e, onClick) => {
  if (typeof onClick === 'function') {
    onClick(e);
  }
};

const ListItemAddButton = ({
  className,
  children,
  contentBefore,
  onClick,
  style,
}) => {
  return (
    <Button
      type="button"
      onClick={onClick ? (e) => handleClick(e, onClick) : null}
    >
      <ListItem
        className={className}
        style={style}
        contentBefore={contentBefore}
        contentPrimary={children}
        withoutBorder
      />
    </Button>
  );
};

ListItemAddButton.propTypes = {
  children: PropTypes.string.isRequired,
  className: PropTypes.string,
  contentBefore: PropTypes.node,
  onClick: PropTypes.func,
  style: PropTypes.object,
};

ListItemAddButton.defaultProps = {
  className: undefined,
  contentBefore: undefined,
  onClick: () => {},
  style: undefined,
};

export default ListItemAddButton;
